import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import { contentStyles } from '@helpers/typography';
import styled, { css } from 'styled-components';
import ButtonStyles from '../Global/Buttons/Button/Button.styles';
import FormStyles from '../Global/Forms/Form.styles';
import CheckboxListStyles from '../Global/Inputs/CheckboxList/CheckboxList.styles';
import { ModalContentContainer, ModalContentInner } from '../Global/Modal/Modal.styles';
export const mustReadModalContainerStyles = css `
  [data-site='ess'] & {
    --borderColor: ${brand.ess.secondary.midGrey};
    --disabledButtonColour: ${brand.ess.secondary.midGrey};
    --fgColour: ${brand.ess.secondary.darkGrey};
  }

  [data-site='mep'] & {
    --borderColor: ${brand.mep.secondary.darkGrey};
    --disabledButtonColour: ${brand.mep.secondary.midGrey};
    --fgColour: ${brand.mep.primary};
  }
`;
export const mustReadModalInnerStyles = css `
  display: flex;
  flex-direction: column;
  color: var(--fgColour);
  overflow: hidden;

  .form-field,
  ${FormStyles.Field} {
    border-top: 1px solid var(--borderColor);
    padding: ${fluid(18, 20)} 0;
  }

  .ktc-checkbox label,
  ${CheckboxListStyles.Label} {
    white-space: normal;
    color: var(--fgColour);
  }
`;
export const mustReadModalTitleStyles = css `
  display: block;
  font-size: ${fluid(18, 20)};
  line-height: ${fluid(26, 30)};
  border-bottom: 1px solid var(--borderColor);
  padding: 0 0 ${fluid(8, 12)};
  margin: 0 0 ${fluid(30, 40)};

  [data-site='ess'] & {
    ${fonts.daxWide.medium};
  }

  [data-site='mep'] & {
    ${fonts.museoSlab.medium};
  }
`;
export const mustReadModalContentStyles = css `
  ${scrollbars};

  position: relative;
  flex-shrink: 1;
  margin-bottom: ${fluid(20, 30)};
  overflow: auto;
  padding-right: 8px;

  span {
    ${contentStyles};
  }
`;
export const mustReadModalIndicatorStyles = css `
  ${transition('opacity', 0.5)};

  --size: ${fluid(32, 56)};

  position: sticky;
  bottom: 0;
  height: 0;

  [data-scrolled='true'] & {
    opacity: 0;
  }

  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    content: '';
    background: linear-gradient(to bottom, transparent, var(--bgColour));
    width: 100%;
    height: var(--size);
  }
`;
export const mustReadModalButtonWrapperStyles = css `
  display: flex;
  justify-content: center;
`;
const Container = styled(ModalContentContainer) `
  ${mustReadModalContainerStyles};
`;
const Inner = styled(ModalContentInner) `
  ${mustReadModalInnerStyles};
`;
const Title = styled.h2 `
  ${mustReadModalTitleStyles};
`;
const Content = styled.div `
  ${mustReadModalContentStyles};
`;
const OverflowIndicator = styled.div `
  ${mustReadModalIndicatorStyles};
`;
const ButtonWrapper = styled.div `
  ${mustReadModalButtonWrapperStyles};

  ${ButtonStyles.Container} {
    &:disabled:disabled:disabled {
      --colourBg: var(--disabledButtonColour);

      &::before,
      &::after {
        opacity: 1;
      }
    }

    @media ${until(Device.MobileLarge)} {
      width: 100%;

      [data-site='ess'] & {
        width: calc(100% - 30px);
        transform: translateX(-15px);
      }
    }
  }
`;
const MustReadModalStyles = {
    Container,
    Inner,
    Title,
    Content,
    OverflowIndicator,
    ButtonWrapper,
};
export default MustReadModalStyles;
